'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddCustomer = function AddCustomer(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("circle", {
    cx: "9",
    cy: "13",
    r: "1.25"
  }), React__default["default"].createElement("circle", {
    cx: "15",
    cy: "13",
    r: "1.25"
  })), React__default["default"].createElement("path", {
    d: "M6,18v-3H4v3H1v2h3v3h2v-3h3v-2H6z"
  }), React__default["default"].createElement("path", {
    d: "M12,2C6.48,2,2,6.48,2,12c0,0.338,0.021,0.672,0.057,1h2.011C4.025,12.673,4,12.339,4,12c0-0.29,0.02-0.58,0.05-0.86\n\tc2.36-1.05,4.23-2.98,5.21-5.37C11.07,8.33,14.05,10,17.42,10c0.78,0,1.53-0.09,2.25-0.26C19.88,10.45,20,11.21,20,12\n\tc0,4.41-3.59,8-8,8c-0.339,0-0.672-0.024-1-0.068v2.012C11.328,21.979,11.662,22,12,22c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z"
  }));
};

var AddCustomer$1 = iconStyles()(AddCustomer);

module.exports = AddCustomer$1;
